import { SidebarItem } from '@backstage/core-components';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

/**
 * Shown only to a Tenant Admin of at least one tenant. Hiding it is a
 * courtesy; the page and the API check the same access again. The page
 * opens on the first tenant the user administers.
 */
export function ServiceAccountsNavItem({ tenants }: { tenants: string[] }) {
  return tenants.length > 0 ? (
    <SidebarItem
      icon={VpnKeyIcon}
      to="/service-accounts"
      text="Service accounts"
    />
  ) : null;
}
